import * as clsApi from "@/js/api/classroomApi";

/** GET response (may include preferredLocale; client may ignore it). */
export type AccountSettingsResponse = {
	use24Hour: boolean;
	preferredLocale?: string;
	chatDisplayName?: string;
};

/** PUT body fields. */
export type UpsertAccountSettingsPayload = {
	use24Hour: boolean;
	chatDisplayName: string;
	preferredLocale: string;
};

export async function getAccountSettings(applianceId: string): Promise<AccountSettingsResponse> {
	const data = await clsApi.Get2<AccountSettingsResponse>(`v1/appliances/${applianceId}/account-settings`);
	if (data === null) {
		throw new Error("Failed to load account settings");
	}
	return data;
}

export async function upsertAccountSettings(applianceId: string, body: UpsertAccountSettingsPayload): Promise<AccountSettingsResponse> {
	const data = await clsApi.Put2<UpsertAccountSettingsPayload, AccountSettingsResponse>(
		`v1/appliances/${applianceId}/account-settings`,
		body
	);
	if (data === null) {
		throw new Error("Failed to save account settings");
	}
	return data;
}
